(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bystella-assembly-videos"] && !Shopify.designMode) return;
  try {
    
  // Assembly videos carousel — horizontal scroll with prev/next buttons.
  // Bound per-section via [data-bystella-asm-root] (replaces an inline script
  // that walked `document.currentScript.previousElementSibling`).
  (function () {
    document.querySelectorAll('[data-bystella-asm-root]').forEach(function (root) {
      if (root.dataset.bystellaAsmBound === '1') return;
      root.dataset.bystellaAsmBound = '1';

      var carousel = root.querySelector('[data-bystella-asm-carousel]');
      var track = root.querySelector('[data-bystella-asm-track]');
      var prev = root.querySelector('[data-bystella-asm-nav="prev"]');
      var next = root.querySelector('[data-bystella-asm-nav="next"]');
      if (!carousel || !track) return;

      function step() {
        var slide = track.querySelector('.bystella-assembly-section__slide');
        if (!slide) return carousel.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
        return slide.getBoundingClientRect().width + gap;
      }

      function updateNav() {
        if (!prev || !next) return;
        prev.toggleAttribute('disabled', carousel.scrollLeft <= 4);
        next.toggleAttribute('disabled', carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4);
      }

      if (prev) prev.addEventListener('click', function () { carousel.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { carousel.scrollBy({ left: step(), behavior: 'smooth' }); });
      carousel.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bystella-capabilities"] && !Shopify.designMode) return;
  try {
    
  // Capabilities carousel — horizontal scroll with prev/next buttons.
  // Bound per-section via [data-bystella-cap-root] (replaces an inline script
  // that walked `document.currentScript.previousElementSibling`).
  (function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('[data-bystella-cap-root]').forEach(function (root) {
      if (root.dataset.bystellaCapBound === '1') return;
      root.dataset.bystellaCapBound = '1';

      var carousel = root.querySelector('[data-bystella-cap-carousel]');
      var track = root.querySelector('[data-bystella-cap-track]');
      var prev = root.querySelector('[data-bystella-cap-nav="prev"]');
      var next = root.querySelector('[data-bystella-cap-nav="next"]');
      if (!carousel || !track) return;

      function step() {
        var slide = track.querySelector('.bystella-cap__slide');
        if (!slide) return carousel.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
        return slide.getBoundingClientRect().width + gap;
      }

      function updateNav() {
        if (!prev || !next) return;
        var atStart = carousel.scrollLeft <= 4;
        var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
        prev.toggleAttribute('disabled', atStart);
        next.toggleAttribute('disabled', atEnd);
      }

      var scrollBehavior = function () { return prefersReducedMotion.matches ? 'auto' : 'smooth'; };
      if (prev) prev.addEventListener('click', function () { carousel.scrollBy({ left: -step(), behavior: scrollBehavior() }); });
      if (next) next.addEventListener('click', function () { carousel.scrollBy({ left: step(), behavior: scrollBehavior() }); });
      carousel.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bystella-collection"] && !Shopify.designMode) return;
  try {
    
  // Auto-submit the sort form when the user picks a new option. Replaces an
  // inline `onchange="this.form.submit()"` so we stay CSP-friendly.
  (function () {
    document.querySelectorAll('select[data-bystella-sort-submit]').forEach(function (select) {
      if (select.dataset.bystellaSortBound === '1') return;
      select.dataset.bystellaSortBound = '1';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bystella-exercises"] && !Shopify.designMode) return;
  try {
    
  // Exercise filter toolbar — clicking a filter button shows only items whose
  // [data-bystella-ex-category] matches. Replaces an inline script that walked
  // `document.currentScript.previousElementSibling`.
  (function () {
    document.querySelectorAll('[data-bystella-ex-root]').forEach(function (root) {
      if (root.dataset.bystellaExBound === '1') return;
      root.dataset.bystellaExBound = '1';

      var filters = root.querySelector('[data-bystella-ex-filters]');
      if (!filters) return;
      var items = root.querySelectorAll('[data-bystella-ex-category]');

      filters.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bystella-ex-filter]');
        if (!btn) return;
        var f = btn.getAttribute('data-bystella-ex-filter');
        filters.querySelectorAll('[data-bystella-ex-filter]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        items.forEach(function (item) {
          var cat = item.getAttribute('data-bystella-ex-category');
          item.hidden = f !== 'all' && cat !== f;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bystella-footer"]) return;
  try {
    
  // Cookie preferences button — opens Shopify's customer privacy / consent
  // dialog. Falls back to the older `openConsent` API if `showPreferences`
  // isn't available. Replaces an inline `<script>` block.
  (function () {
    document.querySelectorAll('[data-bystella-cookie-prefs]').forEach(function (btn) {
      if (btn.dataset.bystellaPrefsBound === '1') return;
      btn.dataset.bystellaPrefsBound = '1';
      btn.addEventListener('click', function () {
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
          window.Shopify.customerPrivacy.showPreferences();
        } else if (window.Shopify && window.Shopify.consent && typeof window.Shopify.consent.openConsent === 'function') {
          window.Shopify.consent.openConsent();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
